// TODO: Write unit tests

export function convertUnitsToPixels (value, unit, valueIsDecimal, _dpi) {
  const floatValue = parseFloat(value);
  const dpi = _dpi || INKIVE.C.DPI;
  const ptToPxFactor = dpi / 72;
  const inToCmFactor = dpi / 2.54;

  const getResult = (value, unit) => {
    switch (unit) {
      case 'px':
        return value;
      case 'pt':
        return value * ptToPxFactor;
      case 'in':
        return value * dpi;
      case 'cm':
        return value * inToCmFactor;
      case 'mm':
        return value * inToCmFactor / 10;
      default:
        return value;
    }
  };

  const result = getResult(floatValue, unit);
  return valueIsDecimal ? result : Math.round(result);
}
